// extracted by mini-css-extract-plugin
export default {"container":"styles_container__GnBYr","item":"styles_item__CS7SR","label":"styles_label__wZoYI"};